import { z } from 'zod';

export const dateSourceTypeSchema = z.enum(['PLAN', 'TARGET', 'FORECAST', 'CUSTOM']);

export type DateSourceType = z.infer<typeof dateSourceTypeSchema>;

export const viewDateSourceDTOSchema = z
  .object({
    viewId: z.number().int().positive(),
    dateSourceType: dateSourceTypeSchema,
    startCustomFieldId: z.string().min(1).nullable().optional(),
    finishCustomFieldId: z.string().min(1).nullable().optional(),
  })
  .superRefine(validateCustomFields);

export type ViewDateSourceDTO = z.infer<typeof viewDateSourceDTOSchema>;

export const viewDateSourceUpsertDTOSchema = z
  .object({
    dateSourceType: dateSourceTypeSchema,
    startCustomFieldId: z.string().min(1).nullable().optional(),
    finishCustomFieldId: z.string().min(1).nullable().optional(),
  })
  .strict()
  .superRefine(validateCustomFields);

export type ViewDateSourceUpsertDTO = z.infer<typeof viewDateSourceUpsertDTOSchema>;

function validateCustomFields(
  data: {
    dateSourceType: DateSourceType;
    startCustomFieldId?: string | null;
    finishCustomFieldId?: string | null;
  },
  ctx: z.RefinementCtx,
) {
  if (data.dateSourceType === 'CUSTOM') {
    if (!data.startCustomFieldId || !data.finishCustomFieldId) {
      ctx.addIssue({
        code: 'custom',
        message: 'CUSTOM date source requires startCustomFieldId and finishCustomFieldId',
      });
    }
  } else if (data.startCustomFieldId || data.finishCustomFieldId) {
    ctx.addIssue({
      code: 'custom',
      message: 'custom field ids are only allowed when dateSourceType is CUSTOM',
    });
  }
}
